import { FieldType } from 'onefaceui-react-components';
import { actionCreators } from 'react/api/actions/quickAssignment';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

export const assignEquipmentToRoute = (
  equipment,
  routeId,
  dispatch
) => {
  if (!equipment?.id || !routeId || !dispatch) {
    throw new Error('Missing required parameters for driver assignment');
  }

  const model = new App.Models.RouteEquipmentAssignment();
  const data = {
    route: {
      id: routeId
    },
    equipment: {
      id: equipment.id
    },
    principal: equipment.principal
  };

  const options = {
    routeEquipments: [data],
    routeId
  };

  const removeLoading = () => {
    dispatch(
      actionCreators.toggleAssignLoading({
        triggerLoading: false,
        routeId,
        key: 'equipment'
      })
    );
  };

  const success = (assignment) => {
    Object.assign(equipment, {
      assignmentId: assignment.id
    });

    const routeRouter = new App.Routers.Route();

    routeRouter.getEquipmentsByRoute(options, (equipments) => {
      const foundAssignment = equipments.find(
        (assignmentFind) => equipment.id === assignmentFind.equipment.id
          && !equipment.assignmentId
      );

      const updatedEquipment = foundAssignment
        ? { ...equipment, assignmentId: foundAssignment.id }
        : equipment;

      removeLoading();
      dispatch(
        actionCreators.assignEquipment({
          assignmentId: updatedEquipment.assignmentId,
          equipment: updatedEquipment,
          routeId
        })
      );
    });
  };

  const error = () => {
    removeLoading();
  };

  dispatch(
    actionCreators.toggleAssignLoading({
      triggerLoading: true,
      text: equipment.key,
      key: 'equipment',
      routeId
    })
  );

  model.assignToRoute(options, success, error);
};

export const addTagOptions = (fields) => {
  Object.values(fields).forEach((field) => {
    if (field.type === FieldType.MULTIPLE_SELECT) {
      Object.assign(field, {
        extra: {
          onRequestData: async () => {
            const res = await defaultFetch(
              '/Tag/restrictions?criteria=%7B%22filters%22:%5B%22*%22%5D%7D',
              {
                criteriaChain: [{ or: [{ attr: 'tagType', eq: 'EQUIPMENT' }] }]
              },
              'POST'
            );

            const options = res.map((option) => ({
              label: option.description,
              value: option.id
            }));

            return options;
          }
        }
      });
    }
  });

  return fields;
};

export const equipmentCanBeAssigned = (equipment, equipments) => {
  if (!equipment || !Array.isArray(equipments)) return false;

  const isAssigned = equipments.some((item) => item.id === equipment.id);

  if (equipments.length > 0 && isAssigned) {
    new Greenmile.Components.AlertModal(
      'SpeedAssignment.equipmentAlreadyAssigned'
    ).show();
    return false;
  }

  return true;
};

export const isPrincipal = (equipment, allEquipments) => {
  if (!Array.isArray(allEquipments) || allEquipments.length === 0) return true;

  return !allEquipments.some(
    (eq) => eq.principal && eq.id !== equipment.id
  );
};
